var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"redirect-one-drive-button",on:{"click":_vm.openLink}},[_vm._v(_vm._s(_vm.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }